import {FC, useRef} from 'react'
// import {useAppDispatch, useAppSelector} from '../../../../redux/hooks'
// import {Notifications, ReadNotification} from '../../../../redux/general/generalSlice'
// import {Link} from 'react-router-dom'
// import {showConfirmation, showMessage} from '_metronic/helpers/swalHelper'
// import {t} from 'i18next'
// import echo from 'services/echo'
// import {PendingMessages} from '../../../../redux/chat/chatSlice'
// import {useAuth} from 'app/modules/auth'

const Search: FC = () => {
  // const [menuState] = useState<'main' | 'advanced' | 'preferences'>('main')
  const element = useRef<HTMLDivElement | null>(null)
  // const wrapperElement = useRef<HTMLDivElement | null>(null)
  // const suggestionsElement = useRef<HTMLDivElement | null>(null)
  // const [notifications, setNotifications] = useState<any>([])
  // const dispatch = useAppDispatch()
  // const {notification} = useAppSelector((state) => state.general)
  // const {currentUser} = useAuth()
  // const currentUserId = currentUser?.id

  // const listNotification = () => {
  //   dispatch(Notifications())
  // }

  // useEffect(() => {
  //   setNotifications(notification)
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [notification])

  // useEffect(() => {
  //   listNotification()
  //   console.log('WebSocket endpoint:', `ws://${window.Echo.options.wsHost || ''}`)
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])

  // useEffect(() => {
  //   console.log('channel run in search component')
  //   const uchannel = echo.private(`contacts.${currentUserId}`)
  //   console.log(uchannel)
  //   uchannel.listen('.PendingMessages', (event) => {
  //     console.log('📬 Received PendingMessages event: from app', event)
  //     dispatch(PendingMessages(currentUserId))
  //     // console.log('msg count on console', msgCount)
  //   })

  //   return () => {
  //     echo.leave(uchannel.name)
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [currentUserId])

  // const markAsRead = (id: any) => {
  //   showConfirmation(
  //     t('MESSAGES.CONFIRMATION'),
  //     t('GLOBAL.YES'),
  //     t('GLOBAL.NO'),
  //     () => {
  //       dispatch(ReadNotification(id)).then((res) => {
  //         if (res.meta.requestStatus === 'fulfilled') {
  //           showMessage('Successfully Marked As Read', 'success', () => {
  //             listNotification()
  //           })
  //         } else {
  //           showMessage(t('MESSAGES.SERVER_ERROR'), 'error')
  //         }
  //       })
  //     },
  //     () => showMessage(t('MESSAGES.SERVER_ERROR'), 'error')
  //   )
  // }

  return (
    <>
      <div
        id='kt_header_search'
        className='d-flex align-items-stretch'
        data-kt-search-keypress='true'
        data-kt-search-min-length='2'
        data-kt-search-enter='enter'
        data-kt-search-layout='menu'
        data-kt-menu-trigger='auto'
        data-kt-menu-overflow='false'
        data-kt-menu-permanent='true'
        data-kt-menu-placement='bottom-end'
        ref={element}
      >
        <div
          className='d-flex align-items-center'
          data-kt-search-element='toggle'
          id='kt_header_search_toggle'
        >
          {/* <div className='btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-primary w-35px h-35px position-relative'>
            <span className='fa fa-bell fs-2 text-white text-active-primary'></span>
            {notifications?.length > 0 && (
              <span className='badge badge-circle badge-danger position-absolute top-0 start-100 translate-middle'>
                {notifications.length}
              </span>
            )}
          </div> */}
          {/* <Link
            to='/admin/notifications'
            className='btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-primary w-35px h-35px position-relative'
          >
            <span className='fa fa-bell fs-2 text-white text-active-primary'></span>
             {notifications?.length > 0 && (
              <span className='badge badge-circle badge-danger position-absolute top-0 start-100 translate-middle'>
                {notifications.length}
              </span>
            )} 
          </Link> */}
        </div>

        {/* <div
          data-kt-search-element='content'
          className='menu menu-sub menu-sub-dropdown p-7 w-325px w-md-375px'
        >
          <div
            className={`${menuState === 'main' ? '' : 'd-none'}`}
            ref={wrapperElement}
            data-kt-search-element='wrapper'
          >
            <form
              data-kt-search-element='form'
              className='w-100 position-relative mb-3 d-none'
              autoComplete='off'
            >
              <input
                type='text'
                className='form-control form-control-flush ps-10'
                name='search'
                placeholder='Search...'
                data-kt-search-element='input'
              />
            </form>

            <div ref={suggestionsElement} className='mb-4' data-kt-search-element='main'>
              <div className='d-flex flex-stack fw-bold mb-4'>
                <span className='text-muted fs-6 me-2'>
                  NOTIFICATIONS:{' '}
                  <small className='text-dark'>
                    click on <span className='text-success fa fa-check mx-1'></span> To Mark As Read
                  </small>
                </span>
              </div>

              <div className='scroll-y mh-200px mh-lg-325px'>
                {notifications?.slice(-4).map((item, ind) => (
                  <div className='d-flex justify-content-between align-items-center mb-5' key={ind}>
                    <div className='flex-grow-1'>
                      {typeof item.data === 'string'
                        ? JSON.parse(item.data)?.message
                        : item.data?.message || 'No message available'}
                    </div>
                    <div>
                      <button
                        className='btn btn-sm btn-link fw-bold text-success'
                        onClick={() => markAsRead(item.id)}
                      >
                        <span className='fa fa-check mx-1'></span>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
              <hr />
              <Link to={'/admin/notifications'}>See all notifications</Link>
            </div>
          </div>
        </div> */}
      </div>
    </>
  )
}

export {Search}
